import { Link } from 'components/common/Link';

import { AnalyticsEvent, trackAnalyticsData } from 'utils/analytics';

import css from './CinemaWeek.module.scss';

// TODO: передавать isDarkTheme и сделать фон для "светлой" темы
export const CinemaWeek = () => {
  const linkClickHandler = () => {
    trackAnalyticsData(AnalyticsEvent.DAILY_QUESTION_CINEMA_LINK_CLICK);
  };

  return (
    <Link href="/cinema" onClick={linkClickHandler} className={css.cinemaWeek}>
      Неделя онлайн-кинотеатра «Знание»{'\u00A0'}🤩
    </Link>
  );
};
